import { Component, Inject, OnInit } from '@angular/core';

import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import {
  AdminBlogCategory,
  AdminBlogTag,
  BlogPostDialogData,
  BlogPostEditData,
  BlogPostUpdateRequest
} from '@app/model/blog-management.model';
import {
  BLOG_POST_FORM_LANGUAGES,
  BlogPostFormLanguage,
  BlogPostFormText
} from '../blog-post-form-language.config';
import { BlogManagementDataService } from '@app/services/blog-management-data.service';
import { environment } from '@app/../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';

interface BlogLanguage {
  code: string;
  label: string;
  placeholder: string;
}

@Component({
  selector: 'meu-blog-post-edit',
  templateUrl: './blog-post-edit.component.html',
  styleUrls: ['./blog-post-edit.component.scss']
})
export class BlogPostEditComponent implements OnInit {
  isSaving = false;
  isLoadingPost = false;
  editPostData: BlogPostEditData | null = null;
  selectedLanguageIndex = 0;
  languages: BlogPostFormLanguage[] = BLOG_POST_FORM_LANGUAGES;

  languageForms: { [languageCode: string]: FormGroup } = {
    vi: this.createLanguageForm(),
    en: this.createLanguageForm(),
    zh: this.createLanguageForm()
  };

  settingsForm = new FormGroup({
    categoryId: new FormControl('', [Validators.required]),
    tagIds: new FormControl([]),
    author: new FormControl(''),
    isPublished: new FormControl(false),
    isHot: new FormControl(false),
    isFeatured: new FormControl(false)
  });

  categories: AdminBlogCategory[] = [];
  categoryLoadError = false;

  tags: AdminBlogTag[] = [];
  isLoadingTags = false;
  tagLoadError = false;

  isLoadingOptions = false;

  selectedImageFile: File | null = null;
  imagePreviewUrl = '';
  existingFeaturedImage = '';

  editorConfig = {
    placeholder: 'Nhập nội dung bài viết',
    tabsize: 2,
    height: 'auto',
    minHeight: '45vh',
    dialogsInBody: true,
    uploadImagePath: '/api/upload',
    focus: false,
    tooltip: false,
    fontNamesIgnoreCheck: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times'
    ],
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ]
  };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: BlogPostDialogData,
    private dialogRef: MatDialogRef<BlogPostEditComponent>,
    private blogManagementDataService: BlogManagementDataService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.loadCategories();
    this.loadTags();
    this.loadPostForEdit();
  }

  closeModal() {
    this.dialogRef.close();
  }
  savePost() {
    const vietnameseForm = this.languageForms.vi;
    const englishForm = this.languageForms.en;
    const chineseForm = this.languageForms.zh;

    const languageFormEntries = [
      {
        code: 'vi',
        index: 0,
        label: 'Tiếng Việt',
        form: vietnameseForm
      },
      {
        code: 'en',
        index: 1,
        label: 'English',
        form: englishForm
      },
      {
        code: 'zh',
        index: 2,
        label: '中文',
        form: chineseForm
      }
    ];

    // const invalidLanguage = languageFormEntries.find((language) => language.form.invalid);

    // if (invalidLanguage || this.settingsForm.invalid) {
    //   languageFormEntries.forEach((language) => {
    //     language.form.markAllAsTouched();
    //   });

    //   this.settingsForm.markAllAsTouched();

    //   if (invalidLanguage) {
    //     this.selectedLanguageIndex = invalidLanguage.index;

    //     this.toastr.error('Vui lòng nhập đầy đủ nội dung tab ' + invalidLanguage.label);

    //     return;
    //   }

    //   this.toastr.error('Vui lòng chọn danh mục');

    //   return;
    // }

    // const vietnameseContent = vietnameseForm.value;
    // const englishContent = englishForm.value;
    // const chineseContent = chineseForm.value;
    // const settings = this.settingsForm.value;

    // const payload: BlogPostUpdateRequest = {
    //   post: {
    //     category_id: settings.categoryId,
    //     title: englishContent.title,
    //     slug: englishContent.slug,
    //     excerpt: englishContent.excerpt,
    //     content: englishContent.content,
    //     featured_image: this.editPostData ? this.editPostData.featuredImage : '',
    //     author: (settings.author || '').trim(),
    //     is_published: settings.isPublished,
    //     is_hot: settings.isHot,
    //     is_featured: settings.isFeatured,
    //     published_at: settings.isPublished
    //       ? this.editPostData && this.editPostData.publishedAt
    //         ? this.editPostData.publishedAt
    //         : new Date().toISOString()
    //       : null
    //   },
    //   translations: [
    //     {
    //       language_code: 'vi',
    //       title: vietnameseContent.title,
    //       slug: vietnameseContent.slug,
    //       excerpt: vietnameseContent.excerpt,
    //       content: vietnameseContent.content
    //     },
    //     {
    //       language_code: 'en',
    //       title: englishContent.title,
    //       slug: englishContent.slug,
    //       excerpt: englishContent.excerpt,
    //       content: englishContent.content
    //     },
    //     {
    //       language_code: 'zh',
    //       title: chineseContent.title,
    //       slug: chineseContent.slug,
    //       excerpt: chineseContent.excerpt,
    //       content: chineseContent.content
    //     }
    //   ],
    //   tags: settings.tagIds || []
    // };

    const filledLanguageEntries = languageFormEntries.filter((language) =>
      this.hasLanguageContent(language.form)
    );

    if (filledLanguageEntries.length === 0) {
      this.toastr.error('Vui lòng nhập nội dung cho ít nhất một ngôn ngữ');

      return;
    }

    const invalidLanguage = filledLanguageEntries.find((language) => language.form.invalid);

    if (invalidLanguage) {
      this.markFormTouched(invalidLanguage.form);
      this.selectedLanguageIndex = invalidLanguage.index;

      this.toastr.error('Vui lòng nhập đầy đủ nội dung tab ' + invalidLanguage.label);

      return;
    }

    if (this.settingsForm.invalid) {
      this.settingsForm.markAllAsTouched();
      this.toastr.error('Vui lòng chọn danh mục');

      return;
    }

    const primaryLanguage =
      filledLanguageEntries.find((language) => language.code === 'en') || filledLanguageEntries[0];

    const primaryContent = primaryLanguage.form.value;
    const settings = this.settingsForm.value;

    const payload: BlogPostUpdateRequest = {
      post: {
        category_id: settings.categoryId,
        title: primaryContent.title,
        slug: primaryContent.slug,
        excerpt: primaryContent.excerpt,
        content: primaryContent.content,
        featured_image: this.existingFeaturedImage || '',
        author: (settings.author || '').trim(),
        is_published: settings.isPublished,
        is_hot: settings.isHot,
        is_featured: settings.isFeatured,
        published_at: settings.isPublished ? new Date().toISOString() : null
      },

      translations: filledLanguageEntries.map((language) => {
        const content = language.form.value;

        return {
          language_code: language.code,
          title: content.title,
          slug: content.slug,
          excerpt: content.excerpt,
          content: content.content
        };
      }),

      tags: settings.tagIds || []
    };

    this.isSaving = true;

    const postId = this.dialogData.post.id;

    this.blogManagementDataService
      .updatePost(postId, payload)
      .pipe(
        switchMap((response) => {
          if (!response || !response.success || !this.selectedImageFile) {
            return of(response);
          }

          return this.blogManagementDataService
            .uploadPostImage(postId, this.selectedImageFile)
            .pipe(
              map((uploadResponse) => {
                if (!uploadResponse || !uploadResponse.success) {
                  this.toastr.warning('Đã cập nhật bài viết nhưng không thể tải ảnh đại diện');
                }

                return response;
              }),
              catchError(() => {
                this.toastr.warning('Đã cập nhật bài viết nhưng không thể tải ảnh đại diện');

                return of(response);
              })
            );
        }),
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe(
        (response) => {
          if (!response || !response.success) {
            this.toastr.error(
              response && response.message ? response.message : 'Không thể cập nhật bài viết'
            );

            return;
          }

          this.toastr.success('Cập nhật bài viết thành công');

          this.dialogRef.close({
            updated: true,
            postId: this.dialogData.post.id
          });
        },
        (error) => {
          console.error('Update blog post failed:', error);

          const errorResponse = error && error.error ? error.error : null;
          let message = 'Không thể cập nhật bài viết';

          if (errorResponse && errorResponse.message) {
            message = errorResponse.message;
          } else if (errorResponse && errorResponse.title) {
            message = errorResponse.title;
          }

          this.toastr.error(message);
        }
      );
  }

  private loadPostForEdit() {
    if (!this.dialogData || !this.dialogData.post) {
      this.toastr.error('Không tìm thấy bài viết cần chỉnh sửa');
      this.dialogRef.close();

      return;
    }

    this.isLoadingPost = true;

    this.blogManagementDataService
      .getPostForEdit(this.dialogData.post)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingPost = false;
        })
      )
      .subscribe(
        (postData) => {
          this.editPostData = postData;
          this.fillPostForm(postData);
        },
        (error) => {
          console.error('Load blog post for edit failed:', error);
          this.toastr.error('Không thể tải dữ liệu bài viết');
          this.dialogRef.close();
        }
      );
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || !input.files.length) {
      return;
    }

    const imageFile = input.files[0];

    if (imageFile.type.indexOf('image/') !== 0) {
      this.toastr.error('Vui lòng chọn đúng định dạng hình ảnh');
      input.value = '';

      return;
    }

    this.selectedImageFile = imageFile;

    const reader = new FileReader();

    reader.onload = () => {
      this.imagePreviewUrl = typeof reader.result === 'string' ? reader.result : '';
    };

    reader.readAsDataURL(imageFile);
  }

  onRemoveImage(): void {
    this.selectedImageFile = null;
    this.imagePreviewUrl = '';
    this.existingFeaturedImage = '';
  }

  private getImageUrl(imagePath: string): string {
    if (!imagePath) {
      return '';
    }

    if (imagePath.indexOf('http') === 0) {
      return imagePath;
    }

    return environment.backendhost + imagePath;
  }

  private fillPostForm(postData: BlogPostEditData) {
    this.existingFeaturedImage = postData.featuredImage || '';
    this.imagePreviewUrl = this.getImageUrl(this.existingFeaturedImage);

    this.languageForms.vi.patchValue(postData.languageContents.vi);

    this.languageForms.en.patchValue(postData.languageContents.en);

    this.languageForms.zh.patchValue(postData.languageContents.zh);

    this.settingsForm.patchValue({
      categoryId: postData.categoryId,
      tagIds: postData.tagIds || [],
      author: postData.author,
      isPublished: postData.isPublished,
      isHot: postData.isHot,
      isFeatured: postData.isFeatured
    });
  }

  private createLanguageForm(): FormGroup {
    return new FormGroup({
      title: new FormControl('', [Validators.required]),
      slug: new FormControl('', [Validators.required]),
      excerpt: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required])
    });
  }

  private loadCategories() {
    this.isLoadingOptions = true;
    this.categoryLoadError = false;

    this.blogManagementDataService
      .getCategories()
      .pipe(take(1))
      .subscribe(
        (categories) => {
          this.categories = categories;
          this.isLoadingOptions = false;
        },
        () => {
          this.categories = [];
          this.isLoadingOptions = false;
          this.categoryLoadError = true;
        }
      );
  }

  loadTags() {
    this.isLoadingTags = true;
    this.tagLoadError = false;

    this.blogManagementDataService
      .getTags()
      .pipe(take(1))
      .subscribe(
        (tags) => {
          this.tags = tags;
          this.isLoadingTags = false;
        },
        () => {
          this.tags = [];
          this.isLoadingTags = false;
          this.tagLoadError = true;
        }
      );
  }

  private hasLanguageContent(form: FormGroup): boolean {
    const value = form.value;

    return [value.title, value.slug, value.excerpt, value.content].some(
      (item) => typeof item === 'string' && item.trim().length > 0
    );
  }

  private markFormTouched(form: FormGroup): void {
    Object.keys(form.controls).forEach((controlName) => {
      form.controls[controlName].markAsTouched();
    });
  }

  get activeLanguage(): BlogPostFormLanguage {
    return this.languages[this.selectedLanguageIndex] || this.languages[0];
  }

  get activeText(): BlogPostFormText {
    return this.activeLanguage.text;
  }
}
